import { SET_AREAS } from "./actions";

const initialState = {
  list: [],
  selected: null,
};

const areasReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_AREAS:
      return { ...state, list: action.payload };
    default:
      return state;
  }
};

export default areasReducer;
